import { Action } from '@ngrx/store';
import { Offer } from '@rd/types/offer.type';

export enum OfferTermsActionTypes {
  SHOW_OFFER_TERMS = '[OfferTerms] Show Offer Terms',
}

export class ShowOfferTerms implements Action {
  readonly type = OfferTermsActionTypes.SHOW_OFFER_TERMS;

  constructor(public payload: Offer) {}
}

export type OfferTermsActions = ShowOfferTerms;
